import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import {
  matchDepth,
  matchType,
  matchWidth
} from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import { noProductsWithTypesForSelectedEntity } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import removeAccessoriesForSelectedEntity from 'rangeConfig/smastad/behaviors/removeAccessoriesForSelectedEntity';
import { hideClothRailOrganisers } from 'rangeConfig/smastad/rules/hideMenuRules';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeInterior',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    {
      id: 'interiors-selected-menu-interiors',
      title: 'storageone.productListInteriorsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [
        ProductType.SMASTAD_SHELF,
        ProductType.SMASTAD_CLOTH_RAIL_40,
        ProductType.SMASTAD_CLOTH_RAIL_ASM,
        ProductType.SMASTAD_WIRE_BASKET_ASM,
        ProductType.SMASTAD_RAIL_STRIP_W_HOOKS_ASM,
        ProductType.SMASTAD_CLOTH_RAIL_55_W_HOOKS_ASM
      ],
      productFilters: [matchWidth, matchDepth, matchType]
    },
    {
      id: 'interiors-selected-menu-cloth-rail-organizers',
      title: 'storageone.selectedProductListAddOrganizers',
      cardsTitle: 'name',
      cardsSubtitle: 'communicatedSizeText',
      behaviors: {
        productClicked: [addToTarget],
        productDropped: [addToTarget]
      },
      productTypes: [ProductType.SMASTAD_HANGING_STORAGE_CASE],
      hidden: hideClothRailOrganisers,
      productFilters: [],
      noneOption: {
        behaviors: { removeProducts: [removeAccessoriesForSelectedEntity] },
        selected: noProductsWithTypesForSelectedEntity([ProductType.SMASTAD_HANGING_STORAGE_CASE]),
        title: 'storageone.productListNoClothRailOrganisersOptionTitle'
      }
    }
  ]
};

export default selectedMenu;
